import React from 'react';
import { SVGProps } from './types';

const TickIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeWidth="1.2"
        d="M4.167 11.667l2.916 2.916 8.75-9.166"
      />
    </svg>
  );
};

export { TickIcon };
